const capitalize = str => {
  if (typeof str !== 'string' || str.length === 0) {
    return str;
  }

  return str.charAt(0).toUpperCase() + str.slice(1);
};

export default capitalize;



// WEBPACK FOOTER //
// ./src/utils/capitalize.js